import React from 'react';
import styled from '@emotion/styled';
import { Box, Button, ButtonProps, Grid, Tooltip } from '@mui/material';
import PolarisIcon from './PolarisIcon';
import { convertStylesToStyled } from '@/_utils/utils';

type ButtonAdditionalProps = ButtonProps & {
  label?: string;
  tooltip?: string;
  ['data-testid']?: string;
};

type AllButtonProps = {
  draft?: ButtonAdditionalProps;
  cancel?: ButtonAdditionalProps;
  complete?: ButtonAdditionalProps;
  back?: ButtonAdditionalProps;
};

const StepperButton = ({ draft, cancel, complete, back }: AllButtonProps) => {
  const SaveAsDraftButton = () => (
    <Button sx={{ height: '100%' }} variant="outlined" color="secondary" endIcon={<PolarisIcon icon="draft" height={16} />} {...draft}>
      {draft?.label}
    </Button>
  );

  const completeButton = (
    <Button variant="contained" color="primary" size="large" {...complete}>
      {complete?.label}
    </Button>
  );

  return (
    <ButtonBar sx={{ boxShadow: 4 }}>
      <ButtonsGrid container>
        <Group>
          {back?.onClick && (
            <Button sx={{ ml: 1 }} variant="outlined" color="primary" startIcon={<PolarisIcon icon="left" height={18} />} {...back}>
              {back?.label}
            </Button>
          )}

          {draft?.tooltip ? (
            <Tooltip title={draft?.tooltip} placement="top">
              <div>
                <SaveAsDraftButton />
              </div>
            </Tooltip>
          ) : (
            draft?.onClick && <SaveAsDraftButton />
          )}
        </Group>

        <Group>
          {cancel?.onClick && (
            <CancelButton sx={{ mr: 1 }} variant="text" color="default" {...cancel}>
              {cancel?.label}
            </CancelButton>
          )}

          {complete?.label ? (
            complete?.tooltip ? (
              <Tooltip title={complete?.tooltip} placement="top">
                <div>{completeButton}</div>
              </Tooltip>
            ) : (
              completeButton
            )
          ) : null}
        </Group>
      </ButtonsGrid>
    </ButtonBar>
  );
};

export default StepperButton;

const ButtonBar = styled(Box)`
  background: ${({ theme }) => theme.palette.background.paper};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: ${({ theme }) => theme.spacing(2)};
  z-index: 999;
  ${({ theme }) => convertStylesToStyled(theme.customOverrides?.ButtonBar)}
`;

const ButtonsGrid = styled(Grid)`
  flex: 1;
  display: flex;
  justify-content: space-between;
  & > .MuiButtonBase-root {
    margin: ${({ theme }) => theme.spacing(0, 1)};
  }
  & > .MuiButton-outlinedPrimary {
    background: none;
  }
`;

const CancelButton = styled(Button)`
  opacity: 0.8;
`;

const Group = styled.div`
  display: inline-flex;
  padding-right: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(1)};
`;
